import React from 'react';
import Route from 'react-router/lib/Route';
import IndexRoute from 'react-router/lib/IndexRoute';
import BuoyweatherPageContainer from '../containers/routes/BuoyweatherPageContainer';

const importNotFound = (nextState, cb) => {
  System.import('../containers/routes/NotFound/index.js')
    .then(module => cb(null, module.default))
    .catch((e) => { throw e; });
};

const importHomePage = (nextState, cb) => {
  System.import('../containers/routes/HomePage/index.js')
    .then(module => cb(null, module.default))
    .catch((e) => { throw e; });
};

const importForecastPage = (nextState, cb) => {
  System.import('../containers/routes/ForecastPage/index.js')
    .then(module => cb(null, module.default))
    .catch((e) => { throw e; });
};

const importPrintForecastPage = (nextState, cb) => {
  System.import('../containers/routes/PrintForecastPage/index.js')
    .then(module => cb(null, module.default))
    .catch((e) => { throw e; });
};

const importFavoritesManagerPage = (nextState, cb) => {
  System.import('../containers/pages/FavoritesManager/index.js')
  .then(module => cb(null, module.default))
  .catch((e) => { throw e; });
};

const importAddFavoritePage = (nextState, cb) => {
  System.import('../containers/pages/AddFavoritePage/index.js')
    .then(module => cb(null, module.default))
    .catch((e) => { throw e; });
};

const importChangeUnitsPage = (nextState, cb) => {
  System.import('../containers/pages/ChangeUnitsPage/index.js')
    .then(module => cb(null, module.default))
    .catch((e) => { throw e; });
};

const importMapPage = (nextState, cb) => {
  System.import('../containers/pages/MapPage/index.js')
    .then(module => cb(null, module.default))
    .catch((e) => {
      throw e;
    });
};

const importMapWebview = (nextState, cb) => {
  System.import('../containers/pages/MapWebview/index.js')
    .then(module => cb(null, module.default))
    .catch((e) => {
      throw e;
    });
};

const routes = ([
  <Route path="webview/map" getComponent={importMapWebview} />,
    (<Route path="/" component={BuoyweatherPageContainer}>
      <IndexRoute getComponent={importHomePage} />
      <Route path="forecast/marine-weather/print/(*)@*,*" getComponent={importPrintForecastPage} />
      <Route path="forecast/marine-weather/(*)@*,*" getComponent={importForecastPage} />
      <Route path="/map(/:location)" getComponent={importMapPage} />
      <Route path="/user/settings/favorites" getComponent={importFavoritesManagerPage} />
      <Route path="/user/favorites/create" getComponent={importAddFavoritePage} />
      <Route path="/user/units" getComponent={importChangeUnitsPage} />
      <Route path="*" getComponent={importNotFound} status={404} />
    </Route>),
]);

if (module.hot) {
  /* eslint-disable global-require */
  require('../containers/routes/ForecastPage/index.js');
  /* eslint-enable global-require */
}

export default routes;



// WEBPACK FOOTER //
// ./src/routes/index.js